
/**
 * Account API
 */
export default class Account {
  constructor(axios) {
    this.$axios = axios
  }

  UpdateProfile(firstName, lastName, email) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'post',
        url: '/account',
        data: { firstName, lastName, email }
      })
        .then(({ data }) => {
          resolve(data.account)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  SubscriptionPlans() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/account/plans'
      })
        .then(({ data }) => {
          resolve(data.plans)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  SubscriptionInfo() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/account/subscription'
      })
        .then(({ data }) => {
          data.subscription.active = true
          resolve(data.subscription)
        })
        .catch((err) => {
          // No active subscription
          if(err.response.status === 404) {
            reject()
            return
          }

          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ActivateSubscription(plan, token) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: '/account/subscription',
        data: { plan, token }
      })
        .then(({ data }) => {
          data.subscription.active = true
          resolve(data.subscription)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  CancelSubscription(password, reason, other) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: '/account/subscription/cancel',
        data: { password, reason, other }
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  BillingInfo() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/account/billing'
      })
        .then(({ data }) => {
          resolve(data.billing)
        })
        .catch((err) => {
          // No active subscription
          if(err.response.status === 404) {
            reject()
            return
          }

          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  UpdateBillingInfo(token) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'post',
        url: '/account/billing',
        data: { token }
      })
        .then(({ data }) => {
          resolve(data.billing)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
